//=================================\\
// Header Fix \\
//=================================\\

export default function headerFix() {
	$('header .dropdown .dropdown').css({
		height: 'auto',
		opacity: '1',
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/header-fix.js